<div class="flex items-center justify-center min-h-screen bg-white">
  <div class="text-center">
    <div class="animate-spin h-12 w-12 rounded-full border-t-4 border-gray-700 mx-auto mb-4"></div>
    <p class="text-gray-700 text-lg">กำลังเข้าสู่ระบบผ่าน LINE...</p>
  </div>
</div>
